import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiRSelect, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';
import { Table } from 'antd';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import { Dropdown, Popconfirm, Menu } from 'antd';
import { MdOutlineMoreVert } from "react-icons/md";
import { render } from "react-dom";


export default function AccountMaster() {
  let navigate = useNavigate();
  const [fy] = useOutletContext();
  const location = useLocation();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const [pagenum, setPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [tableDisable, setTableDisable] = useState(false);
  const parsed = queryString.parse(location.search);
  const [initialLoad, setInitLoad] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: getStorage('perpage') ? [20, 50, 100, 500].includes(parseInt(getStorage('perpage'))) ? parseInt(getStorage('perpage')) : 20 : 20,
      showSizeChanger: true,
      pageSizeOptions: [20, 50, 100, 500],
    },

  });


  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });



  const bulkmodal = useModal('bulk_pdf');

  const bulkPdf = (numbers, type, action) => {
    bulkmodal.show({ type, action, ids: numbers }).then((res) => {
      clearSelection()
    });
  }



  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])
    setSelectedRows([])
    setPage(1)
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'account-master', 1), { replace: location.search ? true : false })


  };

  useEffect(() => {
    queryClient.invalidateQueries(['account-master'])
  }, [fy]);

  const handleDelete = (id) => {
    var tid = id.toString();

    setTableDisable(true)
    instance
      .get("/delete_account?id=" + tid)
      .then(function (response) {
        setTableDisable(false)
        if (response.data.status == 'success') {
          queryClient.invalidateQueries(['account-master'])
          clearSelection()
          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }
      })
  }


  const pdf_columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'sno',
      key: 'sno',
    },
    {
      title: 'Account',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Contact Person',
      dataIndex: 'contact_person',
      key: 'contact_person',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
    },


    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
    },

    {
      title: 'Last',
      dataIndex: 'last_sales',
      key: 'last_sales',
    },

  ];


  const items = (e) => [
    {
      key: '1',
      label: <span>Edit</span>,
      disabled: e.can_edit == 1 ? false : true,
      onClick: () => addAccount(e),
    },
    {
      key: '2',
      disabled: e.can_delete == 1 ? false : true,
      label: (
        <Popconfirm
          title="Delete?"
          description="Are you sure to delete this?"
          onConfirm={() => handleDelete(e.id)}
          okText="Yes"
          cancelText="No"
        >
          <span>Delete</span>
        </Popconfirm>
      ),
    },


  ];

  const headers = [
    { label: "Account", key: "name" },
    { label: "Mobile", key: "mobile" },
    { label: "Group", key: "group_name" },
    { label: "GSTIN", key: "gstin" },
    { label: "Address", key: "address" },
    { label: "State", key: "state" },
    { label: "Credit Limit", key: "credit_limit" },



  ];

  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/account_master" + filter
    );

    var dataa = data;
    return dataa;
  }

  const defaultValues = {
    search: null,
    category: '',
    city: '',
  };

  const clearFilter = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    reset(defaultValues)
    navigate(updateFilterUrl({}, 'account-master', 1), { replace: true })
  }


  useEffect(() => {

    const parsed = queryString.parse(location.search);

    if (location.search) {
      //setPage(parseInt(parsed.page))
    } else {
      setPage(1)
      setFilter(defaultValues)
    }



  }, [location]);

  const accountModal = useModal('account');

  const addAccount = (row) => {
    accountModal.show({ data: row }).then((res) => {
      queryClient.invalidateQueries(['account-master'])
    });
  }

  useEffect(() => {


    const parsed = queryString.parse(location.search);

    if (parsed.page) {
      setPage(parseInt(parsed.page))
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: parseInt(parsed.page),
        },
      });
    } else {
      // setPage(1)
    }

    setFilter(parsed)




  }, []);


  const columns = [
    {
      title: 'Name',
      width: '230px',
      dataIndex: 'name',
      sorter: 'name',
      render: (text, row) => (<Link to={`/ledger?party=${row.id}`}>{row.name}</Link>),
      sortOrder: parsed.sort_by == 'name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'name' && parsed.sort == 'desc' ? 'descend' : '',
    },
    {
      title: 'Group',
      width: '100px',
      dataIndex: 'group_name',
      sorter: 'group_name',
      sortOrder: parsed.sort_by == 'group_name' && parsed.sort == 'asc' ? 'ascend' : parsed.sort_by == 'group_name' && parsed.sort == 'desc' ? 'descend' : '',
      render: (text, row) => (<div className="d-flex"><span className="text-truncate" title={row.group_name}>{row.group_name}</span></div>)
    },
    {
      title: 'GSTIN',
      width: '100px',
      dataIndex: 'gstin',
    },
    {
      title: 'Address',
      width: '100px',
      dataIndex: 'address',
    },
    {
      title: 'State',
      width: '100px',
      dataIndex: 'state',
    },
    {
      title: 'Mobile',
      width: '100px',
      dataIndex: 'mobile',
    },
    {
      title: 'Credit Limit',
      width: '100px',
      dataIndex: 'credit_limit',
      render: (text, row) => (<div>{rupees(row.credit_limit)}</div>),
    },
    {
      title: 'Last Sales',
      width: '80px',
      dataIndex: 'last_sales',
    },



    {
      title: '',
      fixed: 'right',
      width: '40px',
      render: (text, row) => (
        <div className="tableaction1">
          <Dropdown menu={{
            items: items(row),
          }}
            trigger={['click']}
          >
            <button className='btn btn-light'><MdOutlineMoreVert /></button>


          </Dropdown>

        </div>


      )
    },

  ];


  useEffect(() => {

    var set_perpage = 0;
    if (location.search) {
      const parsed = queryString.parse(location.search);
      if (parsed.perpage) {
        if ([20, 50, 100, 500].includes(parseInt(parsed.perpage))) {
          setInitLoad(true)
        } else {
          setStorage('perpage', 20)
          set_perpage = 1;
        }

      } else {
        set_perpage = 1;
      }

    } else {
      set_perpage = 1;
    }

    if (set_perpage == 1) {


      navigate(updateFilterUrl(window.location.search, 'account-master', 1), { replace: true })
    }

  }, [location.search]);

  const { data, error, isError, isLoading, isFetching } = useQuery(["account-master", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
    enabled: initialLoad
  });


  const clearSelection = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
  }
  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        search: filter.search,
        city: filter.city,
        category: zstate.categories && filter.category ? filter.category : '',
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {
    if (data) {
      const parsed = queryString.parse(location.search);
      var setpage = 1;
      if (parsed.page) {
        setpage = parseInt(parsed.page);
      }
      if (parsed.page && parseInt(parsed.page) > 1 && data.items.length == 0) {
        let currentUrlParams = new URLSearchParams(window.location.search);

        setpage = Math.ceil(data.total / parseInt(tableParams.pagination.pageSize));
        setPage(setpage)

        currentUrlParams.set('page', setpage);

        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });

        navigate('/account-master?' + currentUrlParams.toString(), { replace: true })
      } else {
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: data.total,
            current: setpage,
          },
        });
      }
    }

  }, [data]);


  const msgModal = useModal('send_wa');

  const sendMsg = (numbers) => {
    msgModal.show({ contacts: numbers, type: 'general' }).then((res) => {
      clearSelection()
    });
  }



  const handleTableChange = (pagination, filters, sorter) => {
    var direction = ''

    if (sorter.order == 'ascend') {
      direction = 'asc';
    } else if (sorter.order == 'descend') {
      direction = 'desc';
    }
    var pg = pagination.current
    setPage(pg)
    let currentUrlParams = new URLSearchParams(window.location.search);

    if (sorter.order) {
      currentUrlParams.set('sort_by', sorter.field);
      currentUrlParams.set('sort', direction);
    } else {
      currentUrlParams.delete('sort_by');
      currentUrlParams.delete('sort');
    }

    currentUrlParams.set('page', pg);
    var perpage = pagination.pageSize
    currentUrlParams.set('perpage', perpage);
    setStorage('perpage', perpage)
    if (location.search) {
      navigate('/account-master?' + currentUrlParams.toString(), { replace: true })
    } else {
      navigate('/account-master?' + currentUrlParams.toString())
    }

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });


  };
  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedRows)
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };

  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Account Master
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Account Master" >

            {data.items &&
              <><ExportPDFButton columns={pdf_columns} data={data.items} title="accounts" company={data.company} company_desc={data.company_desc} heading1="Account Master" heading2={data.filtered} heading3="" />
                <CSVLink data={data.items} filename={"accounts.csv"} headers={headers} className={`btn btn-outline-primary d-inline-flex mx-2 ${data.items.length == 0 && 'disabled'}`} >Export</CSVLink>
              </>
            }
            <UiButton className="btn btn-primary" onClick={() => addAccount()} title="Add" icon="add" disabled={data.access.add == 0 ? true : false}></UiButton>


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4">

            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col">
                    <UiInput
                      label="Search"
                      type="text"

                      name="search"

                      {...register("search")}
                    />
                  </div>

                  <div className="col-md-3">

                    <UiInput
                      label="City"
                      type="text"
                      name="city"
                      {...register("city")}
                      message={errors.city?.message}
                    />
                  </div>

                  <div className="col-md-3">
                    <Controller
                      name="category"
                      control={control}
                      render={({ field }) => (

                        <UiSelect
                          options={zstate.categories}
                          className=""
                          message={errors.category?.message}
                          label="Group"
                          {...field}
                        />

                      )}
                    />
                  </div>













                  <div className="col-md-2" style={{ paddingTop: '28px', minWidth: '200px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="" className="ms-2 btn-light" title="Clear" onClick={() => clearFilter()} />
                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>

            <div style={{ height: '34px' }} className="ps-3">
              {selectedRowKeys && selectedRowKeys.length > 0 && (
                <div className="bulkaction">
                  <div>

                    {data.access.send_account == 1 &&
                      <button className="btn btn-outline-primary btn-sm me-2" onClick={() => sendMsg(selectedRows)}  >Send Message</button>
                    }
                    {data.access.send_ledger == 1 &&
                      <>
                        <button className="btn btn-outline-primary btn-sm me-2" onClick={() => bulkPdf(selectedRowKeys, 'ledger', 'print')}>Print Ledger</button>

                        <button className="btn btn-outline-primary btn-sm me-2" onClick={() => bulkPdf(selectedRowKeys, 'ledger', 'send')}>Send Ledger</button>
                      </>
                    }
                    {data.access.send_due_slip == 1 &&
                      <>
                        <button className="btn btn-outline-primary btn-sm me-2" onClick={() => bulkPdf(selectedRowKeys, 'due_slip', 'print')}>Print Due Slip</button>

                        <button className="btn btn-outline-primary btn-sm me-2" onClick={() => bulkPdf(selectedRowKeys, 'due_slip', 'send')}>Send Due Slip</button>
                      </>
                    }
                    <Popconfirm
                      title="Delete?"
                      description="Are you sure to delete this?"
                      onConfirm={() => handleDelete(selectedRowKeys)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <button className="btn btn-outline-danger btn-sm me-2" disabled={data.access.delete ? false : true}  >Delete</button>
                    </Popconfirm>
                    <button className="btn btn-light btn-sm me-2" onClick={() => clearSelection()}>Clear Selection <div className="badge bg-primary">{selectedRowKeys.length}</div></button>

                  </div>
                </div>
              )}
            </div>




            <Table
              locale={{
                emptyText: (<TableZero title="Accounts" />)
              }}

              size="small"
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={data.items}
              pagination={{ ...tableParams.pagination, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` }}
              loading={{ spinning: (tableDisable || isFetching) }}
              rowSelection={rowSelection}
              onChange={handleTableChange}
              scroll={{
                x: 960,

              }}
            />
          </div>

        </div>
      </div>
    </>
  );
}
